var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemmanagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.124 6.419h-.849a6.304 6.304 0 0 0-.724-1.717l.61-.611a.868.868 0 0 0 .255-.618.87.87 0 0 0-.255-.617l-1.017-1.015a.893.893 0 0 0-1.233 0l-.636.631a6.314 6.314 0 0 0-1.694-.687V.877A.871.871 0 0 0 8.715 0H7.28a.867.867 0 0 0-.86.877v.907a6.33 6.33 0 0 0-1.698.688l-.635-.631a.896.896 0 0 0-1.236 0L1.834 2.855a.877.877 0 0 0-.256.617c0 .233.09.452.255.616l.61.613a6.303 6.303 0 0 0-.724 1.717H.87a.867.867 0 0 0-.87.867v1.436c0 .482.389.86.87.86h.849c.157.614.403 1.194.724 1.72l-.61.614a.868.868 0 0 0-.256.618c0 .233.091.453.256.618l1.016 1.016a.87.87 0 0 0 1.234 0l.638-.632a6.354 6.354 0 0 0 1.698.688v.907c0 .48.378.869.86.869h1.436a.865.865 0 0 0 .866-.87v-.906a6.317 6.317 0 0 0 1.695-.688l.632.63a.866.866 0 0 0 .618.256.87.87 0 0 0 .617-.255l1.017-1.015a.87.87 0 0 0 0-1.234l-.61-.616a6.36 6.36 0 0 0 .724-1.72h.849a.866.866 0 0 0 .877-.86V7.286a.873.873 0 0 0-.876-.867Zm-7.127 4.318c-1.524 0-2.76-1.224-2.76-2.733 0-1.51 1.236-2.732 2.76-2.732 1.524 0 2.76 1.222 2.76 2.732 0 1.51-1.236 2.733-2.76 2.733Z",
    fill: "#505050",
    fillRule: "evenodd",
    "data-name": "Path 36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemmanagementIcon);
export default __webpack_public_path__ + "static/media/systemmanagementIcon.85e12702327bbce32f5a7503b3f8ede7.svg";
export { ForwardRef as ReactComponent };